import { Component } from '@angular/core';
import { ConfirmationComponent } from '../../../Component/Confirmation/confirmation/confirmation.component';
import { Subject } from 'rxjs';
import { SessionService } from '../../../Util/Session/session.service';
import { NgbModal, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { ComboService } from '../../../Model/Combo/combo.service';
import { EmployeeReportingToService } from '../../../Model/ReportingToService/employee-reporting-to.service';
import { ToastService, toastTypeEnum } from '../../../Util/Toast/toast.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { NgSelectModule } from '@ng-select/ng-select';
import { DataTablesModule } from 'angular-datatables';
import { CommonService } from '../../../Model/Common/common.service';

@Component({
  selector: 'app-branch-head',
  standalone: true,
  imports: [NgbModule, FormsModule, ReactiveFormsModule, NgSelectModule, CommonModule, DataTablesModule],
  templateUrl: './branch-head.component.html',
  styleUrl: './branch-head.component.scss'
})
export class BranchHeadComponent {
  isDisabled: boolean = false;
  dtTrigger: Subject<any> = new Subject<any>();
  public User: any = null;
  UserLoad: any[] = [];
  BranchLoad  : any[] = [];
  BranchId: any = null;
  BranchName: string = '';
  BranchMaster : any[] = [];
  BranchDataLoad : any[] = [];
  dtoptions: DataTables.Settings = {};
  constructor(
    private sessionService: SessionService,
    private comboload: ComboService,
    private toast: ToastService,
    private modalService: NgbModal,
    private EmployeeService: EmployeeReportingToService,
    protected common:CommonService
  ) { 
    this.common.getPageRights();
    this.dtoptions = { ...this.common.commonDToptions };
  }

  ngOnInit(): void {
    this.ComboLoad('GetEssUserMaster');
    this.ComboLoad('Branch');
  }
  
  ComboLoad(Combotype: String, Combotype2: string = '', index = 0) {
    this.comboload.ComboLoad({
      'Combotype': Combotype,
    }).subscribe({
      next: (response) => {
        console.log('API Response', response);
         if (Combotype == 'Branch') {
          this.BranchMaster = response.ComboLoad;
        } else if (Combotype == 'GetEssUserMaster') {
          this.UserLoad = response.ComboLoad; 
        }
      },
      complete: () => {
      },
      error: (error) => {
      },  
    });
  }
  Search(){
    this.GetData()
  }
  GetData(){
    const ReportingToData = {
      SelectType: 'ReportingToBranch',
      BranchID: this.BranchId
    }
    this.isDisabled = true;
    this.EmployeeService.EmployeeReportingToSelect(ReportingToData).subscribe(
      data => {
        this.BranchDataLoad = Object.values(data.Table);
        console.log('new data', data);
        this.isDisabled = false;
      },
      error => {
        console.error('Error:', error);
        this.isDisabled = false
      }
    );
  }
  async save(){
    await this.common.getPageRights();
    const modalRef = this.modalService.open(ConfirmationComponent, {
      size: 'md',
      backdrop: 'static',
      windowClass: 'confirmation-modal'
    });

    modalRef.componentInstance.Message = 'Are you Sure want to save?'

    modalRef.result.then((result: any) => {
      if(this.common.PageRight.IsEdit){
        this.Update();
      }
    }).catch(() => {

    });
  }
  Update() {
    if (this.BranchDataLoad.length === 0) {
      this.toast.show({ message: 'No Data Avaliable!', type: toastTypeEnum.warning });
      return
    }
    this.User = this.sessionService.GetUserDetails();
    const Data = this.BranchDataLoad.map(rt => {
      return {
        BranchID: rt.BranchMasterID,
        ApproverUserMasterId: rt.ApproverUserMasterId,
      };
    });
    const ReportData = {
      SelectType: 'Update',
      ESS_ReportingToBranch: Data,
      UserId: this.User.UserId
    }
    console.log('Reporting Data ', ReportData);
    this.isDisabled = true;
    this.EmployeeService.ReportingToBranch(ReportData).subscribe(
      data => {
        if (data.Error_Code == 1) {
          this.toast.show({ message: data.Error_Message, type: toastTypeEnum.success });
          this.BranchDataLoad = []
        }
        else {
          this.toast.show({ message: data.Error_Message, type: toastTypeEnum.warning });
        }
        this.isDisabled = false;
        this.Search();
      },
      error => {
        console.error('Error:', error);
        this.isDisabled = false;
      });
  }
  onSelectChange(type: string) {
    this.BranchDataLoad = [];
    if (type === 'Branch') {
      const selected = this.BranchMaster.find(duty => duty.BranchMasterID === this.BranchId);
      this.BranchName = selected ? selected.BranchName : null;
    }
  }
}
